import styled from "styled-components";

const ModalBackground = styled.a`
  background-color: ${({ theme }) => theme.colors.backdrop};
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

export default ModalBackground;
